import { Box, Button, Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { Delete } from 'mdi-material-ui'
import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import Page from 'src/components/Page'
import PageHeader from 'src/components/page-header'
import ConfirmDialog from 'src/utils/dialog'
import SectionOrderee from 'src/views/order/Orderee'
import SectionOrderer from 'src/views/order/Orderer'
import SectionSummary from 'src/views/order/OrderSummary'
import TableCart from 'src/views/order/TableCart'
import SectionTax from 'src/views/order/Tax'
import { apiService } from '../../../api/axiosClient'

const OrderView = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [reload, setReload] = useState(0)
    const [order, setOrder] = useState([]);    
    const [dlgopen, setDlgopen] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiService.get(`/orders/${params.id}`);
                const payload = response.data;
                setOrder(payload.data);
            } catch (error) {
                console.error('Error fetching order:', error);
            }
        }

        fetchData();
    }, [params.id, reload])

    const onDeleteCart = async (id) => {
        try {
            const response = await apiService.delete(`/carts/order/${id}`);
            toast.success('해당 하위 주문이 삭제되었습니다.');
            navigate(-1);
        } catch (error) {
            console.error('Error deleting cart:', error);
        }
    };

    const onDeleteOrder = async (id) => {
        try {
            const response = await apiService.delete(`/orders/${id}`);
            toast.success('해당 주문이 삭제되었습니다.');
        } catch (error) {
            console.error('Error deleting order:', error);
        }
    };

    const onDelete = (id) => {
        onDeleteCart(id);
        onDeleteOrder(id);
    }

    return (
        <Page title="OrderView">
            <Box>
                <PageHeader
                    title={
                        <Typography variant='h5' color='#666CFF'>
                            주문세부정보
                        </Typography>
                    }
                />

                <ConfirmDialog 
                    open={dlgopen}
                    title={'주문삭제'}
                    content={`주문을 삭제하시면 하위데이타 모두 삭제됩니다.<br/>진행하시겠습니까?`}
                    handleClose={()=>{setDlgopen(false)}}
                    handleConfirm={()=>onDelete(params.id)}
                />

                <Stack direction="row" spacing={4} sx={{ py: 3 }}>
                    <Button sx={{ mr: 1 }} onClick={()=>setDlgopen(true)} color='error' variant='contained' startIcon={<Delete />} >
                        삭제
                    </Button>
                </Stack>

                <Grid container spacing={6} sx={{ mt: 1 }}>
                    <Grid item xs={12}>
                        <TableCart id={params.id} reload={reload} setReload={setReload}/>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SectionOrderer order={order} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SectionOrderee order={order} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SectionSummary order={order} reload={reload} setReload={setReload}/>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SectionTax order={order} />
                    </Grid>
                </Grid>
            </Box>
        </Page>
    )
}

export default OrderView